module.export = {
  DEFAULT_SHAPE_DURATION: 4000,
};
